<script>
import SocialVisitsService from '@/services/SocialVisitsService';

export default {
  name: 'CancelVisitModal',
  props: {
    visit: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      reason: '',
      otherReason: '',
      cancellationReasons: [
        'Needs to be rescheduled by establishment',
        'Resident or Visitor wants to reschedule',
        'Admin error',
        'Resident can’t make it',
        'Operational reasons',
        'Resident doesn’t want this visit',
        'Resident has left the establishment',
        'Not accepted in time',
        'Not approved to contact',
        'Change of Visitor(s)',
        'Other',
      ],
    }
  },
  methods: {
    async cancelVisit() {
      try {
        this.loading = true;
        await SocialVisitsService.cancelVisit(this.visit._id, {
          cancellation_reason: this.reason === 'Other' ? this.otherReason : this.reason,
        })
        this.$toast.success('Visit cancelled', {
          toastClassName: ['toast-std', 'success-toast'],
        });
        this.refresh();
      } catch (e) {
        console.error('Error cancelling visit: ', e);
        this.$toast.error('Error cancelling visit ...', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      } finally {
        this.loading = false;
      }
    },
    isValid() {
      const selected = this.reason.length > 0;
      const otherReason = this.otherReason.length <= 50 && this.otherReason.length > 0;
      if (this.reason === 'Other') {
        return otherReason;
      }
      return selected;
    },
    close() {
      this.$emit('close');
    },
    refresh() {
      this.$emit('refresh');
    },
  },
}
</script>

<template>
  <b-col class="p-0">
    <h3 class="mb-2 text-center">Cancel Visit for</h3>
    <h4 class="mb-2 text-center">{{ visit.prisoner.firstname }} {{ visit.prisoner.lastname }} ({{ visit.prisoner.prisoner_number }})</h4>
    <label>
      Select a reason for cancelling the visit
    </label>
    <select
      v-model="reason"
      class="form-control mb-1"
    >
      <option
        v-for="(reasonText, index) in cancellationReasons"
        :key="index"
        :value="reasonText"
      >
        {{ reasonText }}
      </option>
    </select>
    <div v-if="reason === 'Other'">
      <label>
        Enter a reason for cancelling the visit
      </label>
      <b-form-textarea v-model="otherReason" class="mb-2" maxlength="100" />
    </div>
    <div class="d-flex justify-content-end mb-1">
      <b-button class="mr-1" :disabled="loading" @click="close">
        Close
      </b-button>
      <b-button variant="danger" :disabled="loading || !isValid()" @click="cancelVisit">
        Cancel Visit
      </b-button>
    </div>
  </b-col>
</template>
